import React from 'react';
import {FormProvider, useForm} from 'react-hook-form';
import {Button} from '@mgp-fe/shared/ui/button.tsx';
import {FontAwesomeIcon} from '@fortawesome/react-fontawesome';
import {TextInput} from '@mgp-fe/shared/ui/form/TextInput.tsx';
import {Alert} from '@mgp-fe/shared/ui/alert.tsx';
import useSendSignInLinkMutation, {
	SendSignInLinkMutationData,
} from '@mgp-fe/shared/core-api/mutations/user/send-sign-in-link.ts';
import getClientEnv from '@mgp-fe/shared/utils/env-var-resolver.ts';

export default function SendSignInLinkForm() {
	const form = useForm<Pick<SendSignInLinkMutationData, 'email'>>();
	const signInLinkMutation = useSendSignInLinkMutation();

	return <FormProvider {...form}>
		<h4 className='text-primary'>
			Sign in with email link
		</h4>
		<p className='text-base'>
			Enter your e-mail address and we will send you a link to sign in.
		</p>
		{signInLinkMutation.isSuccess
			? <Alert variant='success'>
				Check your email for sign-in link.
			</Alert>
			: <form
				onSubmit={form.handleSubmit(d => {
					signInLinkMutation.reset();
					signInLinkMutation.mutate({
						...d,
						userType: getClientEnv('appName'),
					});
				})}
				className='flex flex-col horizontal-labels w-full gap-12 relative'>
				<TextInput name='email' label='E-mail' type='email' required/>

				{signInLinkMutation.isError && <Alert variant='destructive' size='xs' className='absolute top-24'>
					User does not exist.
				</Alert>}
				<Button
					type='submit'
					state={signInLinkMutation.status}
					icon={<FontAwesomeIcon icon='paper-plane'/>}>
					Send link to e-mail
				</Button>
			</form>}
	</FormProvider>;
}
